// bind_Modal
import bind_modal from '@/components/AreaBind';

//rule_modal
import rule_modal from '@/components/RuleModal';

// msg_modal
import msg_modal from '@/components/MsgModal';

// // form_modal
// import form_modal from '@/components/Form';


let utils = {
    $bind_modal : bind_modal,
    $rule_modal : rule_modal,
    $msg_modal : msg_modal,
}

export default utils;